import { render, staticRenderFns } from "./ListpageList.vue?vue&type=template&id=5811e9a0"
import script from "./ListpageList.vue?vue&type=script&lang=js"
export * from "./ListpageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports